import React, {ReactElement} from 'react';
import {
  useFutureBudgetAmount,
  useFutureDailyAmount,
  usePristineDetector,
  useKeyboardInput,
} from 'ui/utils/core';
import {usePromoVisible} from 'ui/adapters';
import {useIsIncomeMode} from 'store/UserInput';

import {Section} from 'components/Section';
import {NoMoneyLeft} from './NoMoneyLeft';
import {Greetings} from './Greetings';
import {RandomTip} from './RandomTip';
import {Promo} from './Promo';
import {Income} from './Income';
import {Container} from './style';

const ContentSelector = (): ReactElement => {
  const promoVisible = usePromoVisible();
  const futureBudget = useFutureBudgetAmount();
  const isPristine = usePristineDetector();
  const isIncomeMode = useIsIncomeMode();
  const input = useKeyboardInput();

  if (futureBudget <= 0 && !isIncomeMode) return <NoMoneyLeft />;
  if (input && isIncomeMode) return <Income />;
  if (promoVisible) return <Promo />;
  if (isPristine) return <Greetings />;
  return <RandomTip />;
};

export const Message = (): ReactElement => {
  const futureBudget = useFutureBudgetAmount();
  const futureDaily = useFutureDailyAmount();
  if (futureDaily <= 0 && futureBudget > 0) return null;

  return (
    <Section>
      <Container>
        <ContentSelector />
      </Container>
    </Section>
  );
};
